import { defineMessage, useIntl } from 'react-intl';

import { WishlistSkusDocument } from '@packages/gql/generated/shopping/WishlistSkusDocument';
import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';

import { useBadgeCount } from './useBadgeCount';

const title = defineMessage({
  id: 'slot.wishlist.label',
  defaultMessage: 'Merkzettel',
});

const ariaLabelWithCount = defineMessage<{ readonly count: number | bigint }>({
  id: 'slot.wishlist.aria-label',
  defaultMessage: 'Merkzettel, {count, plural, one {# Artikel} other {# Artikel}}',
});

export const useWishlistLink = () => {
  const { formatMessage } = useIntl();
  const { order } = useConfig();
  const { locale } = useI18n();

  const { badgeCount } = useBadgeCount({
    document: WishlistSkusDocument,
    getCount: (data) => data?.wishlist?.count ?? 0,
    eventNameForExternalUpdates: 'wishlistUpdated',
  });

  const label = formatMessage(title);

  return {
    href: getLocalizedPath(order.paths.wishlist, locale),
    label,
    ariaLabel: badgeCount ? formatMessage(ariaLabelWithCount, { count: badgeCount }) : label,
    badgeCount,
  };
};
